import React from 'react';
import { useTranslation } from 'react-i18next';
import RezultataiClass from '../clases/rezultatai';
import { Loader } from './Loader';

const StatistikaTable = ({ tipai, atsakymai }) => {
  const { t } = useTranslation();

  const Rezai = new RezultataiClass({
    nerodyti: {},
  });

  const info = Rezai.visiAtsakymaiPagalKasPilde(atsakymai);

  if (!info || Object.keys(info).length < 1) return <Loader />;

  return (
    <><div className='statistika-table2'>
      <div className='statistika-table1'>
        <div className='page-content1'>
          <div className='question1'>
            <div className='title2'>
              <p></p>
            </div>
            <div className='answers1'>
              <div className='ball1'>
                <p className='result-atsakymai1' >{t('atstovas')}</p>
              </div>
            </div>
            <div className='answers2'>
              <div className='ball1'>
                <p className='result-atsakymai1'>{t('darbuotojai')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {Object.keys(info).map((imonesPavadinimas, i) => (
  <div key={`table-statiskina-${i}`} className='statistika-table1'>
    <div className='page-content1'>
      <div className='question1'>
        <div className='title1'>
          <p>{imonesPavadinimas}</p>
        </div>
        <div className='answers2'>
          <div className='ball1'>
            {info[imonesPavadinimas]['Įmonės forma'] ? (
              <p className='result-atsakymai1 green1'>{t('atsake')}</p>
            ) : (
              <p className='result-atsakymai1 red1'>{t('neatsake')}</p>
            )}
          </div>
        </div>
        <div key={`single-2-${i}`} className='answers1'>
          <div className='ball1'>
            {info[imonesPavadinimas]['Darbuotojo forma'] ? (
              <p className='result-atsakymai1'>
                {info[imonesPavadinimas]['Darbuotojo forma'].length}
              </p>
            ) : (
              '0'
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
))}
<div style={{ height: '20px' }}></div></div>
    </>
  );
};

export default StatistikaTable;
